import React, { Component } from 'react';
import ReactAutosuggest from 'react-autosuggest';
import _ from 'lodash';

import Picture from '../common/Picture';
import InputFeedback from './InputFeedback';
import noImg from '../img/landing/no-img.jpg';
import noImgWebp from '../img/landing/webp/no-img.webp';

class WodsSearchBar extends Component {
  state = {
    value: '',
    suggestions: [],
    totalResults: 0,
    errors: {},
    showTotalResults: false,
  };

  onSuggestionsFetchRequested = _.debounce(async ({ value }) => {
    try {
      const [wods, headers] = await this.props.searchWodsAction(value);
      this.setState({
        suggestions: wods.map((wod) => {
          return {
            ...wod,
            workoutExercises: wod.workouts
              .map((w) => w.exercises.join(', '))
              .join(' | '),
            description: wod.workouts
              .map((w) => w.description)
              .filter((d) => d)
              .join(' | '),
          };
        }),
        totalResults: headers.total,
        errors: {},
      });
    } catch (err) {
      this.setState({
        errors: err.errors,
      });
    }
  }, 300);

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  onSuggestionSelected = (e, { suggestion }) => {
    this.props.onSelected(suggestion);
    this.setState({ showTotalResults: false });
  };

  getSuggestionName = (suggestion) => suggestion.name;

  renderSuggestion = (suggestion) => {
    return (
      <div key={suggestion.value} className="u-flex">
        <Picture
          src={suggestion.image.url ? suggestion.image.url : noImg}
          srcWebp={suggestion.image.url ? null : noImgWebp}
          className="u-img-responsive u-object-fit u-margin-right-small"
          alt="Workout of the Day Img"
        />
        <div className="u-color-royal-blue u-margin-right-small">
          {suggestion.name}
        </div>
        <div className="u-flex-1 u-no-overflow">
          <div className="u-text-ellipsis">{suggestion.workoutExercises}</div>
          <div className="u-text-ellipsis">{suggestion.description}</div>
        </div>
      </div>
    );
  };

  onChange = (event, { newValue }) => {
    this.setState({ value: newValue });
    this.setState({ showTotalResults: true });

    // reset result on empty values
    if (!newValue) {
      this.props.onSelected(null);
      this.setState({ showTotalResults: false });
    }
  };

  render() {
    const {
      value,
      suggestions,
      totalResults,
      errors,
      showTotalResults,
    } = this.state;

    const inputProps = {
      className: 'c-input',
      placeholder: this.props.placeholder,
      value,
      onChange: this.onChange,
    };
    return (
      <>
        {showTotalResults && <span>Общо резултати: {totalResults}</span>}
        <ReactAutosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          onSuggestionSelected={this.onSuggestionSelected}
          getSuggestionValue={this.getSuggestionName}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
        />
        <InputFeedback message={errors.base || this.props.error} />
      </>
    );
  }
}

export default WodsSearchBar;
